import { NaturalPersonDto } from 'api/actor';
import { ReferentialKey } from 'api/referential';
import { ReferentialDto } from 'api/risk';
import { NaturalPersonFormValues } from 'features/new-actor/types/optim/naturalPersonFormValues';

export function mapNaturalPersonFormValues(
  values: NaturalPersonFormValues,
  referentialsData: Record<ReferentialKey, ReferentialDto[]>,
): NaturalPersonDto {
  const findReferentialId = (referentialType: ReferentialKey, code: string): string => {
    const item = referentialsData[referentialType]?.find((item: any) => item.code === code);
    return item?.id || '';
  };

  const createAddress = () => ({
    line1: values.address,
    line2: (values.additionalAddress || '').trim(),
    line3: undefined,
    zipCode: values.postalCode,
    city: values.city,
    country: values.country,
    formattedAddress: `${values.address},${values.city},${values.country}`,
    latitude: values.latitude || undefined,
    longitude: values.longitude || undefined,
    googlePlaceId: values.googlePlaceId || undefined
  });

  return {
    type: 'physique',
    id: values.id,
    civilityId: findReferentialId(ReferentialKey.Civility, values.civility),
    nationalityId: findReferentialId(ReferentialKey.Nationality, values.nationality),
    lastName: values.lastName,
    firstName: values.firstName,
    phone: values.phone,
    email: values.email,
    birthDate: new Date(values.birthDate),
    birthName: values.birthName,
    birthCountryId: findReferentialId(ReferentialKey.Country, values.birthCountry),
    taxResidenceCountryId: findReferentialId(ReferentialKey.Country, values.taxResidenceCountryId),
    isPPE: values.isPPE,
    isFPE: values.isPPE,
    address: createAddress()
  };
}
